export const GET_CONSULTANCY_LOGBOOK_REQUEST = "GET_CONSULTANCY_LOGBOOK_REQUEST"
export const GET_CONSULTANCY_LOGBOOK_SUCCESS = "GET_CONSULTANCY_LOGBOOK_SUCCESS"
export const GET_CONSULTANCY_LOGBOOK_FAILURE = "GET_CONSULTANCY_LOGBOOK_FAILURE"

export const ADD_CONSULTANCY_LOGBOOK_REQUEST = "ADD_CONSULTANCY_LOGBOOK_REQUEST"
export const ADD_CONSULTANCY_LOGBOOK_SUCCESS = "ADD_CONSULTANCY_LOGBOOK_SUCCESS"
export const ADD_CONSULTANCY_LOGBOOK_FAILURE = "ADD_CONSULTANCY_LOGBOOK_FAILURE"

export const DELETE_CONSULTANCY_LOGBOOK_REQUEST = "DELETE_CONSULTANCY_LOGBOOK_REQUEST"
export const DELETE_CONSULTANCY_LOGBOOK_SUCCESS = "DELETE_CONSULTANCY_LOGBOOK_SUCCESS"
export const DELETE_CONSULTANCY_LOGBOOK_FAILURE = "DELETE_CONSULTANCY_LOGBOOK_FAILURE"

export const EDIT_CONSULTANCY_LOGBOOK_REQUEST = "EDIT_CONSULTANCY_LOGBOOK_REQUEST"
export const EDIT_CONSULTANCY_LOGBOOK_SUCCESS = "EDIT_CONSULTANCY_LOGBOOK_SUCCESS"
export const EDIT_CONSULTANCY_LOGBOOK_FAILURE = "EDIT_CONSULTANCY_LOGBOOK_FAILURE"

export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST"
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS"
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE"

export const GET_CONSULTANCY_LOGBOOK_BY_ID_REQUEST = "GET_CONSULTANCY_LOGBOOK_BY_ID_REQUEST"
export const GET_CONSULTANCY_LOGBOOK_BY_ID_SUCCESS = "GET_CONSULTANCY_LOGBOOK_BY_ID_SUCCESS"
export const GET_CONSULTANCY_LOGBOOK_BY_ID_FAILURE = "GET_CONSULTANCY_LOGBOOK_BY_ID_FAILURE"

export const EXPORT_CONSULTANCY_LOGBOOK_TABLE_REQUEST = "EXPORT_CONSULTANCY_LOGBOOK_TABLE_REQUEST"
export const EXPORT_CONSULTANCY_LOGBOOK_TABLE_SUCCESS = "EXPORT_CONSULTANCY_LOGBOOK_TABLE_SUCCESS"
export const EXPORT_CONSULTANCY_LOGBOOK_TABLE_FAILURE = "EXPORT_CONSULTANCY_LOGBOOK_TABLE_FAILURE"

export const GET_ALL_CONSULTANCY_LOGBOOK_LOG_REQUEST = "GET_ALL_CONSULTANCY_LOGBOOK_LOG_REQUEST";
export const GET_ALL_CONSULTANCY_LOGBOOK_LOG_SUCCESS = "GET_ALL_CONSULTANCY_LOGBOOK_LOG_SUCCESS";
export const GET_ALL_CONSULTANCY_LOGBOOK_LOG_FAILURE = "GET_ALL_CONSULTANCY_LOGBOOK_LOG_FAILURE";

export const RESTORE_CONSULTANCY_LOGBOOK_LOG_REQUEST = "RESTORE_CONSULTANCY_LOGBOOK_LOG_REQUEST";
export const RESTORE_CONSULTANCY_LOGBOOK_LOG_SUCCESS = "RESTORE_CONSULTANCY_LOGBOOK_LOG_SUCCESS";
export const RESTORE_CONSULTANCY_LOGBOOK_LOG_FAILURE = "RESTORE_CONSULTANCY_LOGBOOK_LOG_FAILURE";

export const DELETE_CONSULTANCY_LOGBOOK_LOG_REQUEST = "DELETE_CONSULTANCY_LOGBOOK_LOG_REQUEST";
export const DELETE_CONSULTANCY_LOGBOOK_LOG_SUCCESS = "DELETE_CONSULTANCY_LOGBOOK_LOG_SUCCESS";
export const DELETE_CONSULTANCY_LOGBOOK_LOG_FAILURE = "DELETE_CONSULTANCY_LOGBOOK_LOG_FAILURE";

export const UPDATE_CONSULTANCY_LOGBOOK_ENTITY_PARAMS_SUCCESS ="UPDATE_CONSULTANCY_LOGBOOK_ENTITY_PARAMS_SUCCESS";
export const UPDATE_CONSULTANCY_LOGBOOK_ENTITY_PARAMS_FAILURE ="UPDATE_CONSULTANCY_LOGBOOK_ENTITY_PARAMS_FAILURE";
